/* ============================================================
   DAILE MVP — логика тиров (2026-09).

   Что делает:
   1. Выбор тира на PDP: карточки [data-mvp-tier], состояние .is-on,
      пересчёт кнопки покупки, скрытые свойства в форме.
   2. Переключатель 300/500 внутри Mini: [data-mvp-pieces].
   3. Чекбокс клея (Mini): [data-mvp-glue] — в демо-режиме меняет
      только цену на кнопке.
   4. Память выбора между страницами: localStorage 'daile_mvp_tier' —
      блок форматов на главной пишет, PDP читает и предвыбирает.
   5. Глобальное состояние window.DAILE_MVP + событие 'daile-mvp:tier'
      на document — на него подписаны липкие панели.
   6. Reveal-анимации .dmvp-reveal (IntersectionObserver).
   7. (2026-09-29) Режим custom у блока тиров (custom-puzzle): по умолчанию
      Classic, ссылки [data-mvp-cz-link] ведут в кастомайзер
      с ?set=mini300|mini500|classic|signature выбранного набора;
      (раунд 2) у Mini — галочка клея, как у картин: ссылка получает &glue=1.
   8. (2026-09-29) Фото наборов: миниатюра на карточке [data-mvp-set-photos]
      открывает просмотр только фото этого набора (initSetPhotos).
      Раунд 2: просмотр — карточка по размеру фото (не на весь экран),
      на фото с клеем (alt содержит «glue») — плашка «Glue Kit».

   Демо-режим: у товаров пока один вариант, цены тиров приходят из
   data-атрибутов секции. Кнопка покупки проксирует клик на нативную
   ATC-кнопку и подставляет выбранный вариант в форму —
   выбор виден в свойствах позиции корзины, но скрыт от покупателя
   (символ подчёркивания).
   ============================================================ */
(function () {
  'use strict';
  if (window.__daileMvpLoaded) return;
  window.__daileMvpLoaded = true;

  var LS_KEY = 'daile_mvp_tier';

  window.DAILE_MVP = window.DAILE_MVP || {
    tier: null,        /* 'mini' | 'classic' | 'signature' */
    pieces: 300,       /* Mini: 300 | 500 */
    glue: false,       /* Mini: клей-набор (апсейл) */
    priceText: ''
  };

  function readSaved() {
    try { return localStorage.getItem(LS_KEY); } catch (e) { return null; }
  }
  function saveTier(tier) {
    try { localStorage.setItem(LS_KEY, tier); } catch (e) { /* приватный режим — не страшно */ }
  }

  function emit() {
    try {
      document.dispatchEvent(new CustomEvent('daile-mvp:tier', { detail: window.DAILE_MVP }));
    } catch (e) { /* старый браузер — липкая панель просто не обновится */ }
  }

  /* ---------- блок форматов на главной ---------- */

  function initFormats() {
    var root = document.querySelector('[data-mvp-formats]');
    if (!root) return;
    root.querySelectorAll('[data-mvp-tier]').forEach(function (card) {
      card.addEventListener('click', function () {
        saveTier(card.getAttribute('data-mvp-tier'));
        /* переход делает сама ссылка внутри карточки; если кликнули мимо
           ссылки — ведём в каталог программно */
        var link = card.querySelector('a[href]');
        if (link && !link.contains(document.activeElement)) {
          window.location.href = link.href;
        }
      });
    });
  }

  /* ---------- блок тиров на PDP ---------- */

  function money(n) {
    /* ЗАПАСНОЙ путь, когда у корня нет готовой строки цены от daile-money.
       Раньше здесь приклеивался знак евро, и на американском рынке выходило
       «82 €»: число уже в валюте рынка, а знак чужой. Неверная валюта хуже
       пропуска, поэтому теперь молчим и отдаём пустую строку. */
    return '';
  }

  function initPdpTiers() {
    var root = document.querySelector('[data-mvp-pdp-tiers]');
    if (!root) return;

    function attr(name, fallback) { return parseFloat(root.getAttribute(name)) || fallback; }
    /* Три набора (2026-09-15): Mini с переключателем 300/500, Classic, Signature */
    var priceMini = { 300: attr('data-price-mini-300', 40), 500: attr('data-price-mini-500', 50) };
    var priceSet  = { classic: attr('data-price-classic', 70), signature: attr('data-price-signature', 80) };
    /* Готовые строки цен в валюте витрины — их печатает Liquid через daile-money.
       При переключении рынка (SAR, USD…) знак и порядок берутся из Shopify, а не зашиты в скрипте. */
    var moneyText = {
      'mini:300': root.getAttribute('data-money-mini-300'),
      'mini:500': root.getAttribute('data-money-mini-500'),
      classic:    root.getAttribute('data-money-classic'),
      signature:  root.getAttribute('data-money-signature')
    };
    var variantIds = {
      'mini:300': root.getAttribute('data-variant-mini-300'),
      'mini:500': root.getAttribute('data-variant-mini-500'),
      'classic':  root.getAttribute('data-variant-classic'),
      'signature': root.getAttribute('data-variant-signature')
    };
    var setNames = {
      mini: root.getAttribute('data-label-mini') || 'DAILE MINI',
      classic: root.getAttribute('data-label-classic') || 'DAILE CLASSIC',
      signature: root.getAttribute('data-label-signature') || 'DAILE SIGNATURE'
    };
    var setSubs = {
      mini: root.getAttribute('data-sub-mini') || '',
      classic: root.getAttribute('data-sub-classic') || '',
      signature: root.getAttribute('data-sub-signature') || ''
    };
    function safeText(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function piecesOf(tier) { return tier === 'mini' ? window.DAILE_MVP.pieces : 1000; }
    var piecesLabel = root.getAttribute('data-pieces-label') || 'pieces';
    var setShort = {
      mini: root.getAttribute('data-short-mini') || 'MINI',
      classic: root.getAttribute('data-short-classic') || 'CLASSIC',
      signature: root.getAttribute('data-short-signature') || 'SIGNATURE'
    };

    var cards = root.querySelectorAll('[data-mvp-tier]');
    /* Режим custom (custom-puzzle): в корзину ничего не кладём — кнопка и липкие
       панели ведут в кастомайзер с выбранным набором. */
    var isCustom = root.getAttribute('data-mvp-mode') === 'custom';
    var czUrl = root.getAttribute('data-cz-url') || '';
    var defaultTier = root.getAttribute('data-default-tier') || 'mini';
    var pdp = root.closest('.daile-pdp') || document;
    var form = pdp.querySelector('form[action*="/cart/add"]');
    /* Подпись кнопки ATC. Раунд 6: кнопка — «жидкое стекло» (dv-glass.js кладёт в неё слой
       .dv-glass-material, daile-pdp.js переносит текст в span [data-mvp-atc-label]). Ищем подпись
       при каждой смене (Prestige может перерисовать кнопку) и меняем только текст — слой стекла
       не стираем. */
    function setAtcLabel(text) {
      var el = document.querySelector('[data-mvp-atc-label]');
      if (!el && form) {
        var btn = form.querySelector('button[type="submit"]');
        if (btn) el = btn.querySelector('span:not(.dv-glass-material)') || btn;
      }
      if (!el) return;
      if (!el.querySelector('.dv-glass-material')) { el.textContent = text; return; }
      var node = null;
      Array.prototype.forEach.call(el.childNodes, function (n) {
        if (!node && n.nodeType === 3 && n.nodeValue.trim()) node = n;
      });
      if (node) node.nodeValue = text;
      else el.appendChild(document.createTextNode(text));
    }

    function currentVariantId() {
      var st = window.DAILE_MVP;
      return variantIds[st.tier === 'mini' ? 'mini:' + st.pieces : st.tier] || null;
    }
    function basePrice(tier) {
      if (tier === 'mini') return priceMini[window.DAILE_MVP.pieces] || priceMini[300];
      return priceSet[tier] || priceSet.signature;
    }
    var gluePrice = attr('data-price-glue', 9);
    var glueVariantId = root.getAttribute('data-glue-variant');
    function currentPrice() {
      var p = basePrice(window.DAILE_MVP.tier);
      if (window.DAILE_MVP.tier === 'mini' && window.DAILE_MVP.glue) p += gluePrice;
      return p;
    }
    function moneyFor(tier, pieces) {
      var key = tier === 'mini' ? 'mini:' + (pieces || window.DAILE_MVP.pieces) : tier;
      return moneyText[key] || money(basePrice(tier));
    }
    /* цена над кнопкой с учётом клея — тоже готовой строкой из Liquid, чтобы формат
       валюты не расходился с остальными ценами на странице */
    function moneyTotal() {
      var st = window.DAILE_MVP;
      if (st.tier === 'mini' && st.glue) {
        return root.getAttribute('data-money-mini-' + st.pieces + '-glue') || money(currentPrice());
      }
      return moneyFor(st.tier, st.pieces);
    }

    /* В корзину должен уйти ВЫБРАННЫЙ вариант: подменяем скрытое поле id формы
       и держим в согласии нативный variant-picker (он нужен быстрой покупке). */
    function syncVariantInput() {
      if (!form) return;
      var st = window.DAILE_MVP;
      var id = currentVariantId();
      var key = st.tier === 'mini' ? 'mini-' + st.pieces : st.tier;
      var available = !!id && root.getAttribute('data-available-' + key) === 'true';
      var withGlue = st.tier === 'mini' && st.glue;
      var glueAvailable = !!glueVariantId && root.getAttribute('data-glue-available') === 'true';
      st.available = available && (!withGlue || glueAvailable);
      st.variantId = id;
      form._daileMvpSelection = {
        variantId: id,
        available: st.available,
        addonVariantId: withGlue && glueAvailable ? glueVariantId : null
      };
      var input = form.querySelector('input[name="id"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden'; input.name = 'id'; form.appendChild(input);
      }
      var nextId = st.available ? String(id) : '';
      var changed = input.value !== nextId || input.disabled === st.available;
      input.value = nextId;
      input.disabled = !st.available;
      var labels = window.DAILE_CART_T || {};
      var unavailable = labels.js_cart_unavailable || 'This set is currently unavailable.';
      var addLabel = labels.js_pdp_add_to_cart || 'Add to cart';
      var buttons = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]'));
      document.querySelectorAll('[data-daile-sticky-add]').forEach(function (button) { buttons.push(button); });
      buttons.forEach(function (button) {
        button.disabled = !st.available;
        button.setAttribute('aria-disabled', st.available ? 'false' : 'true');
      });
      setAtcLabel(st.available ? addLabel : unavailable);
      form.querySelectorAll('.shopify-payment-button').forEach(function (button) {
        button.hidden = !st.available || withGlue;
        button.style.display = !st.available || withGlue ? 'none' : 'block';
      });
      if (changed) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
        if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
          try { window.Shopify.PaymentButton.init(); } catch (e) {}
        }
      }
    }

    /* Обводка выбора. Две дуги идут от середины верха (там бейдж) вниз по бокам
       и смыкаются внизу. Геометрию считаем в реальных пикселях карточки: при
       растянутом viewBox скруглениям достаётся разный радиус по осям и углы
       перестают совпадать с border-radius. */
    function sizeTraces() {
      /* Сначала только читаем размеры, потом только пишем в DOM: вперемешку
         это заставляло браузер пересчитывать раскладку на каждую карточку. */
      var box = [];
      cards.forEach(function (c) {
        var svg = c.querySelector('.dmvp-tier__trace');
        if (!svg) { box.push(null); return; }
        /* svg лежит по inset:0, то есть по padding-box карточки — значит и мерить
           надо padding-box (clientWidth/Height), а радиус брать внутренний. */
        var w = c.clientWidth, h = c.clientHeight;
        if (!w || !h) { box.push(null); return; }
        var cs = getComputedStyle(c);
        var bw = parseFloat(cs.borderLeftWidth) || 0;
        var raw = parseFloat(cs.borderTopLeftRadius);
        if (!isFinite(raw)) raw = 10;
        /* радиус не может быть больше половины стороны — иначе дуга выворачивается */
        var r = Math.min(Math.max(0, raw - bw), Math.min(w, h) / 2);
        box.push({ svg: svg, w: w, h: h, r: r });
      });
      box.forEach(function (b) {
        if (!b) return;
        var w = b.w, h = b.h, r = b.r, mid = w / 2;
        b.svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
        var dl = 'M' + mid + ' 0 H' + r + ' A' + r + ' ' + r + ' 0 0 0 0 ' + r +
          ' V' + (h - r) + ' A' + r + ' ' + r + ' 0 0 0 ' + r + ' ' + h + ' H' + mid;
        var dr = 'M' + mid + ' 0 H' + (w - r) + ' A' + r + ' ' + r + ' 0 0 1 ' + w + ' ' + r +
          ' V' + (h - r) + ' A' + r + ' ' + r + ' 0 0 1 ' + (w - r) + ' ' + h + ' H' + mid;
        b.svg.querySelectorAll('.dmvp-tier__trace-l').forEach(function (el) { el.setAttribute('d', dl); });
        b.svg.querySelectorAll('.dmvp-tier__trace-r').forEach(function (el) { el.setAttribute('d', dr); });
        /* пока размеров нет, дуги скрыты стилем — теперь их можно показывать */
        b.svg.setAttribute('data-sized', '');
      });
    }
    sizeTraces();
    if (window.ResizeObserver) { new ResizeObserver(sizeTraces).observe(root); }
    else { window.addEventListener('resize', sizeTraces); }

    /* Обводка карточки рисуется, только когда эту карточку видно целиком.
       Следим за каждой отдельно: блок из трёх карточек на телефоне выше экрана,
       и по нему «видно целиком» наступало задолго до самой карточки.
       Класс is-seen ставится один раз и больше не снимается. */
    function markSeen(card) {
      if (card && !card.classList.contains('is-seen')) card.classList.add('is-seen');
    }
    (function watchCards() {
      /* клик по карточке = человек её точно видит */
      cards.forEach(function (c) {
        c.addEventListener('click', function () { markSeen(c); }, true);
      });
      if (!window.IntersectionObserver) { cards.forEach(markSeen); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var vh = window.innerHeight || 0;
          /* «видно целиком» = либо карточка помещается в экран и видна вся,
             либо она выше экрана и занимает почти весь экран */
          var need = Math.min(en.boundingClientRect.height, vh * 0.85);
          if (en.intersectionRect.height >= need - 1) {
            markSeen(en.target);
            io.unobserve(en.target);
          }
        });
      }, { threshold: [0, 0.25, 0.5, 0.75, 0.9, 1] });
      cards.forEach(function (c) { io.observe(c); });
    })();

    function render() {
      var st = window.DAILE_MVP;
      /* Страховка от несуществующего сочетания: у Mini бывает только 300 и 500.
         Если в состоянии оказалось что-то другое, возвращаемся к 300, иначе
         ломаются и цена, и выбор варианта, и фильтр галереи. */
      if (st.tier === 'mini' && !priceMini[st.pieces]) st.pieces = 300;
      cards.forEach(function (c) {
        var on = c.getAttribute('data-mvp-tier') === st.tier;
        c.classList.toggle('is-on', on);
        /* когда набор меняют не кликом по карточке (например кнопкой 300/500),
           переключатель надо синхронизировать вручную */
        var radio = c.querySelector('.dmvp-tier__radio');
        if (radio && radio.checked !== on) radio.checked = on;
      });
      root.querySelectorAll('[data-mvp-pieces]').forEach(function (b) {
        /* капсула горит, только когда выбран сам набор Mini */
        b.classList.toggle('is-on', st.tier === 'mini' && parseInt(b.getAttribute('data-mvp-pieces'), 10) === st.pieces);
      });
      /* неизменяемая капсула «1000» у Classic и Signature темнеет вместе со своей карточкой */
      root.querySelectorAll('.dmvp-pieces__btn.is-static').forEach(function (b) {
        var card = b.closest('[data-mvp-tier]');
        b.classList.toggle('is-on', !!card && card.getAttribute('data-mvp-tier') === st.tier);
      });
      /* цена и характеристики Mini следуют за переключателем 300/500 */
      var miniPrice = root.querySelector('[data-mvp-tier="mini"] [data-mvp-price]');
      if (miniPrice) miniPrice.textContent = moneyFor('mini', st.pieces);
      var sizeEl = root.querySelector('[data-mvp-size]');
      if (sizeEl) sizeEl.textContent = sizeEl.getAttribute('data-size-' + st.pieces) || sizeEl.textContent;
      var timeEl = root.querySelector('[data-mvp-time]');
      if (timeEl) timeEl.textContent = timeEl.getAttribute('data-time-' + st.pieces) || timeEl.textContent;

      st.priceText = moneyTotal();
      /* Над кнопкой: цена крупно и подпись набора. Текст самой кнопки не трогаем —
         там остаётся штатное «Add to cart» темы. */
      var headPrice = document.querySelector('[data-mvp-atc-price]');
      if (headPrice) headPrice.textContent = st.priceText;
      var headSub = document.querySelector('[data-mvp-atc-sub]');
      if (headSub) {
        /* Этикетка над ценой, как подпись под работой в музее: слева фирменная
           связка DAILE + набор, волосяная линия во всю оставшуюся ширину,
           справа число деталей. Цена внизу остаётся единственной крупной. */
        /* у Mini клей — выбор покупателя, поэтому подписываем его состояние;
           у Classic и Signature клей входит всегда, приписка была бы шумом */
        var glueNote = '';
        /* (раунд 2) клей у Mini есть и на custom-puzzle — приписка как у картин */
        if (st.tier === 'mini') {
          var gTxt = st.glue ? root.getAttribute('data-glue-with') : root.getAttribute('data-glue-without');
          if (gTxt) glueNote = '<span class="dmvp-atc-head__glue">' + safeText(gTxt) + '</span>';
        }
        headSub.innerHTML = 'DAILE <em>' + safeText(setShort[st.tier]) + '</em> <span class="dmvp-atc-head__sep">|</span> ' +
                            '<b class="dmvp-num">' + piecesOf(st.tier) + '</b><span class="dmvp-atc-head__unit">' + safeText(piecesLabel) + '</span>' +
                            glueNote;
      }

      /* мобильная липкая панель: «DAILE MINI | 300 PIECES» над ценой */
      document.querySelectorAll('[data-mvp-sticky-sub]').forEach(function (el) {
        el.hidden = false;
        /* две части, чтобы на узком экране строка ломалась только у разделителя */
        el.innerHTML = '<span>' + safeText(setShort[st.tier]) + '</span> <span class="daile-sticky__sub-pieces">| ' + piecesOf(st.tier) + ' ' + safeText(piecesLabel) + '</span>';
      });
      /* десктопная липкая панель: в самом названии часть после « | » заменяем подписью набора —
         «“The Kiss” — DAILE x Gustav Klimt | 300 · The Compact Art Puzzle Gift Set» */
      document.querySelectorAll('[data-mvp-sticky-name]').forEach(function (el) {
        if (!el.dataset.base) el.dataset.base = el.textContent.split('|')[0].trim();
        /* «… | 1000 pieces Complete Art Puzzle Set» — цифра Hanken 450, подпись набора без «The» */
        el.innerHTML = safeText(el.dataset.base) + ' | <b class="dmvp-num">' + piecesOf(st.tier) + '</b> ' + safeText(piecesLabel) + ' ' + safeText(setSubs[st.tier]);
      });

      /* ключ набора для кастомайзера: mini300 | mini500 | classic | signature.
         (раунд 2) Галочка клея у Mini уходит туда же: &glue=1 — кастомайзер сам
         отмечает клей на шаге Review (assets/dv-customizer.js, загрузка страницы). */
      st.czSet = st.tier === 'mini' ? 'mini' + (st.pieces === 500 ? '500' : '300') : st.tier;
      st.czGlue = st.tier === 'mini' && !!st.glue;
      if (czUrl) {
        document.querySelectorAll('[data-mvp-cz-link]').forEach(function (a) {
          a.setAttribute('href', czUrl + '?set=' + st.czSet + (st.czGlue ? '&glue=1' : ''));
        });
      }
      /* миниатюра Mini показывает набор выбранного размера (300 или 500) */
      root.querySelectorAll('[data-mvp-set-thumb]').forEach(function (img) {
        var src = img.getAttribute('data-src-' + (st.pieces === 500 ? '500' : '300'));
        if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      });

      syncVariantInput();
      emit();
    }

    /* Выбор набора теперь делает сам радиопереключатель: клик по карточке
       попадает в подпись-перекрытие, клавиатура работает штатными стрелками.
       Нам остаётся только слушать смену. */
    cards.forEach(function (card) {
      var radio = card.querySelector('.dmvp-tier__radio');
      if (!radio) return;
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        window.DAILE_MVP.tier = card.getAttribute('data-mvp-tier');
        render();
      });
    });

    root.querySelectorAll('[data-mvp-pieces]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        window.DAILE_MVP.pieces = parseInt(b.getAttribute('data-mvp-pieces'), 10) || 300;
        window.DAILE_MVP.tier = 'mini';
        saveTier('mini');
        render();
      });
    });

    var glue = root.querySelector('[data-mvp-glue] input');
    if (glue) {
      glue.addEventListener('change', function () {
        window.DAILE_MVP.glue = glue.checked;
        window.DAILE_MVP.tier = 'mini';
        render();
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        syncVariantInput();
        if (!window.DAILE_MVP.available) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }

    /* ---------- стартовое состояние ----------
       По умолчанию страница открывается на Mini 300: память прошлого выбора
       убрана намеренно, покупатель ждёт одинаковый стартовый экран, а не
       вчерашний свой клик.

       Исключение — переход по ссылке, которая набор уже назвала. Тогда
       открываем именно его. Понимаем два вида ссылок:
         ?variant=<id>  — родной параметр Shopify, приходит из каталога и из
                          писем; сверяем со списком data-variant-* на корне;
         ?set=classic   — человекочитаемый псевдоним (mini300 | mini-300 |
                          300 | mini500 | classic | signature) на случай
                          ссылок, которые пишутся руками.
       Ничего не найдено или значение чужое — молча остаёмся на Mini 300. */
    function startFromUrl() {
      var q;
      try { q = new URLSearchParams(window.location.search); }
      catch (e) { return null; }

      var variant = q.get('variant');
      if (variant) {
        for (var key in variantIds) {
          if (variantIds[key] && String(variantIds[key]) === String(variant)) {
            return key;
          }
        }
      }

      var alias = (q.get('set') || '').toLowerCase().replace(/[\s_-]/g, '');
      var map = {
        mini300: 'mini:300', '300': 'mini:300',
        mini500: 'mini:500', '500': 'mini:500',
        classic: 'classic',  '1000': 'classic',
        signature: 'signature'
      };
      return map[alias] || null;
    }

    var startKey = startFromUrl();
    if (startKey === 'mini:500') {
      window.DAILE_MVP.tier = 'mini';
      window.DAILE_MVP.pieces = 500;
    } else if (startKey === 'mini:300') {
      window.DAILE_MVP.tier = 'mini';
      window.DAILE_MVP.pieces = 300;
    } else if (startKey === 'classic' || startKey === 'signature') {
      /* pieces НЕ трогаем. У Classic и Signature число деталей всегда 1000 и
         берётся из самого набора, а записанная сюда 1000 оставалась в состоянии
         после переключения на Mini: получалось несуществующее сочетание
         mini + 1000, при котором цена печаталась запасным путём в евро, а в
         корзину уходил вариант Classic. */
      window.DAILE_MVP.tier = startKey;
    } else if (defaultTier === 'classic' || defaultTier === 'signature') {
      /* custom-puzzle открывается на Classic (data-default-tier) */
      window.DAILE_MVP.tier = defaultTier;
      window.DAILE_MVP.pieces = 300;
    } else {
      window.DAILE_MVP.tier = 'mini';
      window.DAILE_MVP.pieces = 300;
    }
    /* галочка клея: состояние берём с самого флажка (браузер восстанавливает его
       при возврате «назад»), чтобы цена и ссылка не расходились с тем, что видно */
    window.DAILE_MVP.glue = !!(glue && glue.checked);
    render();
  }

  /* ---------- фото наборов: миниатюра на карточке → просмотр ----------
     (2026-09-29) У каждой карточки набора — квадратная фотография
     [data-mvp-set-photos="mini|classic|signature"]. Клик открывает просмотр
     ТОЛЬКО фото этого набора и набор НЕ выбирает (stopPropagation; кнопка
     лежит над подписью-перекрытием карточки).
     Какие фото: та же схема меток, что у галереи (snippets/product-gallery.liquid,
     initTierGallery ниже): метка «#set:…» в alt, для Mini — «mini» и
     «mini-<300|500>» по выбранному размеру. Список фото кладёт Liquid в
     <script type="application/json" data-mvp-set-photos-data>. Нет ни одного
     помеченного фото — показываем фото набора с главной (fallback).
     Просмотр — нативный <dialog> (showModal): стрелки, свайп, Escape, фокус
     не выходит из окна и возвращается на миниатюру. */
  function initSetPhotos() {
    var root = document.querySelector('[data-mvp-pdp-tiers]');
    if (!root) return;
    var openers = root.querySelectorAll('[data-mvp-set-photos]');
    if (!openers.length) return;

    var data = null;
    function getData() {
      if (data) return data;
      var el = root.querySelector('[data-mvp-set-photos-data]');
      try { data = JSON.parse(el ? el.textContent : ''); } catch (e) { data = null; }
      if (!data || typeof data !== 'object') data = {};
      if (!Array.isArray(data.media)) data.media = [];
      if (!data.fallback) data.fallback = {};
      return data;
    }
    function pieces() {
      return (window.DAILE_MVP && window.DAILE_MVP.pieces === 500) ? 500 : 300;
    }
    function photosFor(set) {
      var d = getData();
      var keys = set === 'mini' ? ['mini', 'mini-' + pieces()] : [set];
      var list = d.media.filter(function (m) {
        return String(m.tags || '').split(',').some(function (t) {
          return keys.indexOf(t.trim()) !== -1;
        });
      });
      if (!list.length) {
        var fb = d.fallback[set === 'mini' ? 'mini-' + pieces() : set];
        if (fb) list = [fb];
      }
      return list;
    }
    function titleFor(set) {
      var name = root.getAttribute('data-label-' + set) || ('DAILE ' + set.toUpperCase());
      if (set === 'mini') name += ' · ' + pieces();
      return name;
    }
    function isRtl() {
      return (document.documentElement.getAttribute('dir') || document.body.getAttribute('dir') || '').toLowerCase() === 'rtl';
    }
    function reduced() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    function svg(path) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + path + '</svg>';
    }

    /* (раунд 6, 2026-09-30) Просмотр — «работа в паспарту на винной стене»: винная карточка
       с золотой кромкой; внутри фото в бумажном паспарту с золотой нитью; под фото — винная
       панель: название набора золотыми капсами, счётчик тонкими золотыми цифрами, подпись,
       золотые точки. Стрелки и крестик — «жидкое стекло» шапки (dv-glass.js: data-dv-glass с
       оптикой плашки шапки, значения читаются с неё). Кадры сменяются наплывом (два слоя <img>).
       Вокруг — только размытие страницы. Стили: assets/dv-pdp-legacy-colors.css, раздел 12.
       Классы .dmvp-sv* (прежние .dmvp-lb* в daile-mvp.css больше не используются). */
    var dlg = null, stage, layers = [], front = 0, labelEl, capEl, countEl, dotsEl, prevBtn, nextBtn, closeBtn, tagEl;
    var list = [], index = 0, opener = null, prevOverflow = '', loadToken = 0, busyTimer = 0;
    var canModal = typeof HTMLDialogElement === 'function' && 'showModal' in document.createElement('dialog');
    var glueRe = /glue/i;
    var glueLabel = root.getAttribute('data-t-glue') || 'Glue Kit';

    /* оптика стекла — как у плашки шапки (sections/dv-header.liquid): все её data-dv-glass*;
       нет шапки — её значения на 2026-09-30 */
    function glassAttrs() {
      var pill = document.querySelector('[data-dv-header-pill]');
      var out = {};
      if (pill) {
        Array.prototype.forEach.call(pill.attributes, function (a) {
          if (a.name.indexOf('data-dv-glass') === 0) out[a.name] = a.value;
        });
      }
      if (!out['data-dv-glass']) {
        out = { 'data-dv-glass': '8', 'data-dv-glass-rim': '.5', 'data-dv-glass-bend': '1', 'data-dv-glass-dispersion': '.1', 'data-dv-glass-saturate': '1.5', 'data-dv-glass-clear': '.45' };
      }
      return Object.keys(out).map(function (n) {
        return n + '="' + String(out[n]).replace(/[^0-9.]/g, '') + '"';
      }).join(' ');
    }
    function pad(n) { return n < 10 ? '0' + n : String(n); }

    /* Размер фото — из пропорции кадра: карточка целиком (кромка, паспарту, панель) вписывается
       в экран с полями --sv-gutter. «Обвес» вокруг фото меряется по живой карточке. */
    function fit() {
      if (!dlg || !list.length) return;
      var m = list[index] || {};
      var ar = (m.w && m.h) ? m.w / m.h : 0.8;
      var vw = document.documentElement.clientWidth || window.innerWidth;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var cs = window.getComputedStyle(dlg);
      var gutter = parseFloat(cs.getPropertyValue('--sv-gutter')) || 12;
      var maxCard = parseFloat(cs.getPropertyValue('--sv-max')) || 1100;
      var open = isOpen() && stage.offsetWidth > 0;
      var extraW = open ? dlg.offsetWidth - stage.offsetWidth : 40;
      var extraH = open ? dlg.offsetHeight - stage.offsetHeight : 190;
      var maxW = Math.min(vw - 2 * gutter, maxCard) - extraW;
      var maxH = vh - 2 * gutter - extraH;
      var w = Math.max(120, Math.min(maxW, maxH * ar));
      dlg.style.setProperty('--sv-w', Math.round(w) + 'px');
      dlg.style.setProperty('--sv-h', Math.round(w / ar) + 'px');
    }

    function build() {
      dlg = document.createElement(canModal ? 'dialog' : 'div');
      dlg.className = 'dmvp-sv';
      dlg.setAttribute('aria-modal', 'true');
      if (!canModal) { dlg.setAttribute('role', 'dialog'); dlg.hidden = true; }
      var glass = glassAttrs();
      var img = '<img class="dmvp-sv__img" alt="" decoding="async" draggable="false">';
      dlg.innerHTML =
        '<div class="dmvp-sv__mat">' +
          '<div class="dmvp-sv__stage">' + img + img +
            '<span class="dmvp-sv__tag" hidden></span>' +
            '<button type="button" class="dmvp-sv__btn dmvp-sv__close" ' + glass + '>' + svg('<path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/>') + '</button>' +
            '<button type="button" class="dmvp-sv__btn dmvp-sv__arrow dmvp-sv__arrow--prev" ' + glass + '>' + svg('<path d="M20 12H4.5M10 6.5L4.5 12l5.5 5.5"/>') + '</button>' +
            '<button type="button" class="dmvp-sv__btn dmvp-sv__arrow dmvp-sv__arrow--next" ' + glass + '>' + svg('<path d="M4 12h15.5M14 6.5l5.5 5.5-5.5 5.5"/>') + '</button>' +
          '</div>' +
        '</div>' +
        '<div class="dmvp-sv__panel">' +
          '<div class="dmvp-sv__head">' +
            '<p class="dmvp-sv__label"></p>' +
            '<p class="dmvp-sv__count" aria-live="polite"></p>' +
          '</div>' +
          '<p class="dmvp-sv__cap"></p>' +
          '<div class="dmvp-sv__dots" aria-hidden="true"></div>' +
        '</div>';
      stage = dlg.querySelector('.dmvp-sv__stage');
      layers = Array.prototype.slice.call(dlg.querySelectorAll('.dmvp-sv__img'));
      labelEl = dlg.querySelector('.dmvp-sv__label');
      capEl = dlg.querySelector('.dmvp-sv__cap');
      countEl = dlg.querySelector('.dmvp-sv__count');
      dotsEl = dlg.querySelector('.dmvp-sv__dots');
      tagEl = dlg.querySelector('.dmvp-sv__tag');
      tagEl.textContent = glueLabel;
      prevBtn = dlg.querySelector('.dmvp-sv__arrow--prev');
      nextBtn = dlg.querySelector('.dmvp-sv__arrow--next');
      closeBtn = dlg.querySelector('.dmvp-sv__close');
      closeBtn.setAttribute('aria-label', root.getAttribute('data-t-close') || 'Close');
      prevBtn.setAttribute('aria-label', root.getAttribute('data-t-prev') || 'Previous');
      nextBtn.setAttribute('aria-label', root.getAttribute('data-t-next') || 'Next');
      document.body.appendChild(dlg);
      /* стекло кнопок монтирует dv-glass.js (окно лежит в <body>, вне секций — запускаем вручную) */
      if (window.DV && typeof window.DV.init === 'function') {
        try { window.DV.init(dlg); } catch (e) {}
      }

      closeBtn.addEventListener('click', close);
      prevBtn.addEventListener('click', function () { go(-1); });
      nextBtn.addEventListener('click', function () { go(1); });
      dotsEl.addEventListener('click', function (e) {
        var dot = e.target.closest ? e.target.closest('[data-sv-dot]') : null;
        if (dot) show(parseInt(dot.getAttribute('data-sv-dot'), 10) || 0);
      });
      /* клик мимо карточки (по размытой странице) закрывает: у <dialog> он приходит в сам dialog,
         поэтому сверяем точку с рамкой карточки */
      dlg.addEventListener('click', function (e) {
        if (e.target !== dlg) return;
        var r = dlg.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
      });
      if (canModal) {
        dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
      }
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var forward = e.key === 'ArrowRight';
          if (isRtl()) forward = !forward;
          go(forward ? 1 : -1);
          return;
        }
        if (e.key === 'Tab') {
          /* фокус не уходит из окна: по кругу между его кнопками */
          var f = [closeBtn, prevBtn, nextBtn].filter(function (b) { return !b.hidden && !b.disabled; });
          if (!f.length) return;
          var i = f.indexOf(document.activeElement);
          e.preventDefault();
          var n = e.shiftKey ? (i <= 0 ? f.length - 1 : i - 1) : (i === -1 || i === f.length - 1 ? 0 : i + 1);
          f[n].focus();
        }
      });

      /* свайп: палец/мышь тянут фото, отпустили дальше порога — следующее */
      var x0 = null, y0 = 0, dx = 0, pid = null, dragged = null;
      stage.addEventListener('pointerdown', function (e) {
        if (list.length < 2 || e.button > 0 || e.target.closest('button')) return;
        x0 = e.clientX; y0 = e.clientY; dx = 0; pid = e.pointerId;
        dragged = layers[front];
        try { stage.setPointerCapture(pid); } catch (err) {}
        dragged.style.transition = 'none';
      });
      stage.addEventListener('pointermove', function (e) {
        if (x0 === null || e.pointerId !== pid) return;
        dx = e.clientX - x0;
        if (Math.abs(dx) > Math.abs(e.clientY - y0)) dragged.style.transform = 'translateX(' + dx + 'px)';
      });
      function endSwipe(e) {
        if (x0 === null || (e && e.pointerId !== pid)) return;
        x0 = null;
        var el = dragged;
        el.style.transition = '';
        if (Math.abs(dx) > 45) {
          var forward = dx < 0;
          if (isRtl()) forward = !forward;
          /* уходящий кадр гаснет там, куда его утянули; сдвиг снимаем после наплыва */
          go(forward ? 1 : -1);
          window.setTimeout(function () { if (el !== layers[front]) el.style.transform = ''; }, 600);
          if (el === layers[front]) el.style.transform = '';
        } else {
          el.style.transform = '';
        }
        dx = 0;
      }
      stage.addEventListener('pointerup', endSwipe);
      stage.addEventListener('pointercancel', endSwipe);
      window.addEventListener('resize', function () { if (isOpen()) fit(); });
    }

    function isOpen() {
      return !!dlg && (canModal ? dlg.open : !dlg.hidden);
    }

    function setLayer(el, m) {
      el.classList.remove('is-loaded');
      el.removeAttribute('srcset');
      if (m.srcset) { el.setAttribute('srcset', m.srcset); el.setAttribute('sizes', '(max-width: 749px) 94vw, min(1100px, 70vw)'); }
      el.setAttribute('src', m.src);
      if (m.w && m.h) { el.setAttribute('width', m.w); el.setAttribute('height', m.h); }
      el.setAttribute('alt', m.alt || '');
    }

    /* Кадр i. Подпись, счётчик и точки меняются сразу; фото — наплывом, когда новый кадр
       загрузился (до этого виден прежний; дольше 250 мс — тонкая золотая полоска загрузки). */
    function show(i, instant) {
      if (!list.length) return;
      index = (i + list.length) % list.length;
      var m = list[index];
      var token = ++loadToken;
      var cur = layers[front];
      var nextEl = instant ? cur : layers[1 - front];
      setLayer(nextEl, m);
      var reveal = function () {
        if (token !== loadToken) return;
        window.clearTimeout(busyTimer);
        stage.classList.remove('is-busy');
        nextEl.classList.add('is-loaded');
        if (nextEl !== cur) {
          nextEl.classList.add('is-front');
          cur.classList.remove('is-front');
          cur.setAttribute('aria-hidden', 'true');
          front = 1 - front;
        } else {
          nextEl.classList.add('is-front');
        }
        nextEl.removeAttribute('aria-hidden');
        fit();
      };
      window.clearTimeout(busyTimer);
      if (nextEl.complete && nextEl.naturalWidth) reveal();
      else {
        busyTimer = window.setTimeout(function () { if (token === loadToken) stage.classList.add('is-busy'); }, 250);
        nextEl.onload = reveal;
        nextEl.onerror = reveal;
      }
      /* подпись «Glue & display kit» — на фото, где alt говорит о клее */
      tagEl.hidden = !glueRe.test(m.alt || '');
      capEl.textContent = m.alt || '';
      countEl.innerHTML = '<span class="dmvp-sv__num">' + pad(index + 1) + '</span><span class="dmvp-sv__of">/</span><span class="dmvp-sv__num">' + pad(list.length) + '</span>';
      countEl.setAttribute('aria-label', (index + 1) + ' / ' + list.length);
      Array.prototype.forEach.call(dotsEl.children, function (d, k) { d.classList.toggle('is-on', k === index); });
      fit();
      /* соседние кадры — заранее, чтобы листалось без пустых пауз */
      [index + 1, index - 1].forEach(function (k) {
        var n = list[(k + list.length) % list.length];
        if (n && n !== m) { var pre = new Image(); if (n.srcset) { pre.sizes = cur.getAttribute('sizes') || ''; pre.srcset = n.srcset; } pre.src = n.src; }
      });
    }
    function go(step) {
      if (list.length < 2) return;
      show(index + step);
    }

    function open(set, from) {
      list = photosFor(set);
      if (!list.length) return;
      if (!dlg) build();
      opener = from || null;
      labelEl.textContent = titleFor(set);
      dlg.setAttribute('aria-label', (root.getAttribute('data-t-photos') || 'Set photos') + ': ' + titleFor(set));
      var many = list.length > 1;
      prevBtn.hidden = !many; nextBtn.hidden = !many; countEl.hidden = !many;
      dlg.classList.toggle('is-single', !many);
      var dots = '';
      if (many && list.length <= 12) {
        for (var k = 0; k < list.length; k++) dots += '<button type="button" class="dmvp-sv__dot" tabindex="-1" data-sv-dot="' + k + '"><i></i></button>';
      }
      dotsEl.innerHTML = dots;
      dotsEl.hidden = !dots;
      /* с чистого листа: оба слоя пустые, первый кадр — без наплыва */
      layers.forEach(function (el) { el.classList.remove('is-front', 'is-loaded'); el.style.transform = ''; el.removeAttribute('src'); el.removeAttribute('srcset'); });
      show(0, true);
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      if (canModal) { if (!dlg.open) dlg.showModal(); }
      else { dlg.hidden = false; dlg.setAttribute('open', ''); }
      fit();
      /* второй замер: панель могла перенести подпись на другую ширину */
      requestAnimationFrame(fit);
      dlg.classList.remove('is-in');
      if (reduced()) { dlg.classList.add('is-in'); }
      else { requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-in'); }); }); }
      closeBtn.focus();
    }
    function close() {
      if (!dlg) return;
      loadToken++;
      window.clearTimeout(busyTimer);
      stage.classList.remove('is-busy');
      dlg.classList.remove('is-in');
      if (canModal) { if (dlg.open) dlg.close(); }
      else { dlg.hidden = true; dlg.removeAttribute('open'); }
      document.documentElement.style.overflow = prevOverflow;
      layers.forEach(function (el) { el.removeAttribute('src'); el.removeAttribute('srcset'); el.classList.remove('is-front', 'is-loaded'); });
      if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); } }
    }
    openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        /* фото открывает просмотр и НЕ выбирает набор */
        e.preventDefault();
        e.stopPropagation();
        open(btn.getAttribute('data-mvp-set-photos'), btn);
      });
      /* нажатие мышью/пальцем тоже не должно доходить до карточки */
      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
        btn.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
      });
    });
  }

  /* ---------- галерея по выбранному набору ----------
     Разметку даёт snippets/product-gallery.liquid (mvp_tier_gallery: true):
     слайды/миниатюры/точки помечены [data-mvp-tier-media]:
       "mini" | "classic" | "signature" — фото наборов (метка #set: в alt),
       "legacy" — прежние фото товара (показываются, если фото набора нет).
     Главное фото картины без пометки — видно всегда. */
  function initTierGallery() {
    var gallery = document.querySelector('product-gallery');
    if (!gallery || !gallery.querySelector('[data-mvp-tier-media]')) return;
    var carousel = gallery.querySelector('scroll-carousel');
    var lastKey = null;   /* какой набор показан сейчас; null — ещё ни одного */

    /* Метки в alt: #set:mini | classic | signature, плюс уточнённые
       #set:mini-300 и #set:mini-500 — у Mini первое фото после картины своё
       для 300 и для 500 деталей. Кадр показываем, если он помечен ЛЮБЫМ из
       подходящих ключей. */
    function keysFor(st) {
      var tier = (st && st.tier) ? st.tier : 'mini';
      var keys = [tier];
      if (tier === 'mini' && st && st.pieces) keys.push('mini-' + st.pieces);
      return keys;
    }

    function apply(st) {
      var keys = keysFor(st);
      var key = keys[0];
      /* в метке может быть несколько наборов через запятую: "classic,signature" */
      gallery.querySelectorAll('[data-mvp-tier-media]').forEach(function (el) {
        var list = (el.getAttribute('data-mvp-tier-media') || '').split(',');
        var show = false;
        for (var i = 0; i < list.length && !show; i++) {
          var tag = list[i].trim();
          for (var k = 0; k < keys.length; k++) {
            if (tag === keys[k]) { show = true; break; }
          }
        }
        el.hidden = !show;
      });
      /* Кадры переключаем родным API карусели Prestige: carousel.cells отдаёт
         только видимые кадры, select(i) доводит ленту до нужного. Раньше здесь
         стоял scrollIntoView — он тянул за собой и страницу, отсюда прыжок
         наверх при смене набора. */
      if (!carousel) return;
      var firstRun = (lastKey === null);
      var changed = (!firstRun && key !== lastKey);
      lastKey = key;
      if (firstRun) {
        carousel.select(0, { instant: true });
        /* На телефоне при первом открытии показываем набор одним кругом:
           от картины по кадрам и обратно к картине. Старт — только когда
           страница догрузилась (событие шлёт initPdpTiers). На компе галерея
           и так перед глазами, там стартуем спокойно, без движения. */
        /* один круг через 3 секунды после захода — не ждём, пока человек
           долистает до наборов, фото он видит сразу */
        if (isNarrow() && !noMotion()) { autoRun(0, STEP_DELAY); }
        return;
      }
      /* Переключение 300/500 внутри Mini меняет только первый кадр (mini-300 →
         mini-500). Фильтр выше уже переставил видимость; страницу и
         автопрокрутку при этом не дёргаем — набор тот же. */
      if (!changed) return;
      autoStop();
      var startAt = carousel.cells.length > 1 ? 1 : 0;   /* с первого кадра набора, не с картины */
      if (noMotion()) { carousel.select(startAt); return; }
      /* Сначала на карточке смыкается обводка, и только под конец этого
         движения лента едет к первому кадру набора.
         Раунд 7 (владелец: «подтягивание к фото — идея хорошая, но лагает,
         отключи»): страница к галерее больше не едет (bringGalleryIntoView
         не вызывается) — меняется только кадр в галерее. */
      setTimeout(function () {
        glideTo(startAt);
        autoRun(startAt, STEP_DELAY, true);
      }, TRACE_LEAD);
    }

    /* ——— автопрокрутка галереи ———
       Один круг: от стартового кадра по порядку до последнего, затем возврат
       на картину — и стоп. Любое касание, свайп, колесо или клик по миниатюре
       выключают её сразу. */
    var STEP_DELAY = 3000;    /* пауза между кадрами */
    var TRACE_LEAD = 1300;    /* обводка рисуется 1.65с — трогаемся ближе к концу */
    var autoTimer = null;

    function noMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    function isNarrow() {
      return !!(window.matchMedia && window.matchMedia('(max-width: 999px)').matches);
    }

    /* Плавный переход к кадру. Родной select() уезжает нативным smooth-скроллом
       — он короткий и резкий, длительность не задать. Поэтому: instant-select
       обновляет состояние карусели и миниатюры, позицию отматываем назад и
       ведём своей анимацией с мягкой кривой. */
    /* Переход к кадру делает сама тема: select() уезжает нативным плавным
       скроллом. Свой tween пробовали — он ломал ощущение свайпа и заставлял
       рамку миниатюры прыгать (тема пересчитывает кадр по событию scroll,
       а tween шлёт их каждый кадр). */
    function glideTo(i) {
      if (!carousel) return;
      carousel.select(i, { instant: noMotion() });
    }

    function autoStop() {
      if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
    }
    function autoRun(startAt, firstDelay, alreadyThere) {
      autoStop();
      if (!carousel || noMotion()) return;
      if (carousel.cells.length < 2) return;
      var i = startAt;
      if (!alreadyThere) glideTo(i);
      autoTimer = setTimeout(function step() {
        autoTimer = null;
        if (i >= carousel.cells.length - 1) {
          glideTo(0);   /* круг замкнулся на картине — дальше не крутим */
          return;
        }
        i += 1;
        glideTo(i);
        autoTimer = setTimeout(step, STEP_DELAY);
      }, firstDelay || STEP_DELAY);
    }

    function userTook() { autoStop(); }
    if (carousel) {
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
        carousel.addEventListener(ev, userTook, { passive: true });
      });
      gallery.querySelectorAll('.product-gallery__thumbnail').forEach(function (b) {
        b.addEventListener('click', userTook);
      });
    }

    document.addEventListener('daile-mvp:tier', function (e) { apply(e.detail); });
    if (window.DAILE_MVP && window.DAILE_MVP.tier) apply(window.DAILE_MVP);
  }

  /* ---------- «что внутри»: переключение тиров ---------- */

  function initWhatsInside() {
    document.querySelectorAll('[data-mvp-wi]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-mvp-wi-tab]');
      var panes = root.querySelectorAll('[data-mvp-wi-pane]');
      function show(key) {
        tabs.forEach(function (t) {
          t.classList.toggle('is-on', t.getAttribute('data-mvp-wi-tab') === key);
        });
        panes.forEach(function (p) {
          p.classList.toggle('is-on', p.getAttribute('data-mvp-wi-pane') === key);
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-mvp-wi-tab')); });
      });
      /* по умолчанию — выбранный тир, если он есть */
      var start = (window.DAILE_MVP && window.DAILE_MVP.tier) || 'signature';
      if (!root.querySelector('[data-mvp-wi-tab="' + start + '"]')) start = 'signature';
      show(start);
      document.addEventListener('daile-mvp:tier', function (e) {
        if (e.detail && e.detail.tier) show(e.detail.tier);
      });
    });
  }

  /* ---------- липкие панели: показываем выбранный тир ---------- */

  function initStickySync() {
    var targets = document.querySelectorAll('[data-mvp-sticky-price]');
    if (!targets.length) return;
    function apply(st) {
      if (!st || !st.priceText) return;
      targets.forEach(function (el) { el.textContent = st.priceText; });
    }
    document.addEventListener('daile-mvp:tier', function (e) { apply(e.detail); });
    /* Первый выбор тира случается ДО этой подписки (initPdpTiers идёт раньше
       по порядку init) — применяем текущее состояние сразу, иначе в капсуле
       остаётся нативная цена варианта до первого клика. */
    apply(window.DAILE_MVP);
  }

  /* ---------- reveal ---------- */

  function initReveal() {
    var els = document.querySelectorAll('.dmvp-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }


  /* ---------- подарок к дате (PDP) ---------- */

  /* ---------- «не готов сегодня — напомним» ----------
     Почта уходит в Klaviyo клиентским API (публичный company_id, он и так
     в коде каждой страницы). Подписка идёт в отдельный список напоминаний —
     это и есть согласие на одно письмо; рассылка отдельной галочкой.
     Само письмо шлёт сценарий Klaviyo по дате-свойству reminder_due. */

  function initRemind() {
    var root = document.querySelector('[data-mvp-remind]');
    if (!root) return;

    var company = root.getAttribute('data-kl-company');
    var listId = root.getAttribute('data-kl-list');
    var toggle = root.querySelector('[data-mvp-remind-toggle]');
    var emailEl = root.querySelector('[data-mvp-remind-email]');
    var newsEl = root.querySelector('[data-mvp-remind-news]');
    var saveEl = root.querySelector('[data-mvp-remind-save]');
    var msgEl = root.querySelector('[data-mvp-remind-msg]');
    var chips = root.querySelectorAll('[data-mvp-remind-in]');
    var days = 7;

    if (toggle) {
      toggle.addEventListener('click', function () {
        var on = !root.classList.contains('is-open');
        root.classList.toggle('is-open', on);
        toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (on && emailEl) emailEl.focus();
      });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        days = parseInt(c.getAttribute('data-mvp-remind-in'), 10) || 7;
        chips.forEach(function (x) { x.classList.toggle('is-on', x === c); });
      });
    });

    function say(text, bad) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.classList.toggle('is-bad', !!bad);
      msgEl.hidden = false;
    }

    /* Дата напоминания в YYYY-MM-DD — Klaviyo распознаёт её как дату,
       и сценарий может стартовать именно в этот день. */
    function dueDate() {
      var d = new Date(new Date().getTime() + days * 864e5);
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    }
    function niceDate(iso) {
      try { return new Date(iso + 'T12:00:00').toLocaleDateString(document.documentElement.lang || undefined,
        { day: 'numeric', month: 'long', numberingSystem: 'latn' }); } catch (e) { return iso; }
    }

    function props(due) {
      var st = window.DAILE_MVP || {};
      var title = document.querySelector('.daile-pdp__title, h1');
      return {
        reminder_due: due,
        reminder_product: title ? title.textContent.trim() : document.title,
        reminder_url: location.origin + location.pathname,
        reminder_set: st.tier || '',
        reminder_pieces: st.pieces || '',
        reminder_price: st.priceText || '',
        daile_newsletter_opt_in: !!(newsEl && newsEl.checked)
      };
    }

    function klaviyo(path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      });
    }

    if (saveEl) {
      saveEl.addEventListener('click', function () {
        var email = (emailEl && emailEl.value || '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) {
          say(root.getAttribute('data-msg-bad'), true);
          if (emailEl) emailEl.focus();
          return;
        }
        if (!company || !listId) { say(root.getAttribute('data-msg-err'), true); return; }

        var due = dueDate();
        var p = props(due);
        saveEl.disabled = true;

        /* Подписка в список напоминаний — согласие на это одно письмо */
        klaviyo('subscriptions', {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'PDP reminder',
              profile: { data: { type: 'profile', attributes: { email: email, properties: p } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        }).then(function (res) {
          if (!res.ok) throw new Error('klaviyo ' + res.status);
          /* событие для метрики и как второй возможный триггер сценария */
          klaviyo('events', {
            data: {
              type: 'event',
              attributes: {
                properties: p,
                metric: { data: { type: 'metric', attributes: { name: 'Requested Reminder' } } },
                profile: { data: { type: 'profile', attributes: { email: email } } }
              }
            }
          }).catch(function () { /* метрика не критична */ });
          root.classList.add('is-done');
          say(root.getAttribute('data-msg-ok') + ' ' + niceDate(due) + '.');
        }).catch(function () {
          saveEl.disabled = false;
          say(root.getAttribute('data-msg-err'), true);
        });
      });
    }
    if (emailEl) {
      emailEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); saveEl.click(); }
      });
    }
  }

  function initAccount() {
    var root = document.querySelector('[data-mvp-acc]');
    if (!root) return;
    var tabs = root.querySelectorAll('[data-mvp-acc-tab]');
    var panes = root.querySelectorAll('[data-mvp-acc-pane]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var key = t.getAttribute('data-mvp-acc-tab');
        tabs.forEach(function (x) { x.classList.toggle('is-on', x === t); });
        panes.forEach(function (p) {
          p.classList.toggle('is-on', p.getAttribute('data-mvp-acc-pane') === key);
        });
      });
    });
    root.querySelectorAll('[data-mvp-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-mvp-copy');
        var done = btn.getAttribute('data-mvp-copied') || 'Copied';
        try { navigator.clipboard.writeText(code); } catch (e) { /* демо */ }
        var orig = btn.textContent;
        btn.textContent = done;
        setTimeout(function () { btn.textContent = orig; }, 1600);
      });
    });
  }

  function init() {
    initFormats();
    initTierGallery();   /* подписка ДО initPdpTiers — первый emit сразу применится */
    initPdpTiers();
    initSetPhotos();
    initWhatsInside();
    initStickySync();
    initRemind();
    initAccount();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
